import React from 'react';
import styles from './SmallLogoSVG.module.scss';

const SmallLogoSVG: React.FC = () => {
  return (
    <svg
      className={styles.smallLogoSvg}
      xmlns="http://www.w3.org/2000/svg"
      width="102"
      height="24"
      fill="none"
    >
      <path
        fill="#FCFFBB"
        d="M3.338.63H0v22.739H8.443v-3.53H3.338V.63ZM14.48.646v22.723h8.445v-3.53h-5.107v-6.108h4.728v-3.53H17.82V4.176h5.106V.646H14.48ZM93.074.646v22.723h8.445v-3.53h-5.107v-6.108h4.729v-3.53h-4.729V4.176h5.107V.646h-8.445ZM67.764 13.9 63.018.63H59.68v22.739h3.338V10.195l4.746 13.174h3.338V.629h-3.338V13.9Z"
      />
      <path
        fill="#C2E533"
        d="M33.89 19.84 31.183.645h-3.535l3.234 22.723h5.942L40.058.646h-3.535L33.89 19.839ZM45.738.646l-3.234 22.723h3.535L48.67 4.176 51.38 23.37h3.535L51.678.646h-5.94Z"
      />
      <path
        fill="#FCFFBB"
        d="M82.952.63h-5.827v22.74h5.828c2.398 0 4.34-1.954 4.34-4.367V4.999c0-2.412-1.944-4.368-4.34-4.368V.63Zm.956 12.898v4.782a1.6 1.6 0 0 1-1.594 1.605h-1.851V4.083h1.85a1.6 1.6 0 0 1 1.595 1.605v7.84Z"
      />
    </svg>
  );
};

export default SmallLogoSVG;
